import { render } from "./QkImage.vue?vue&type=template&id=4b0b3c9a&scoped=true"
import script from "./QkImage.vue?vue&type=script&lang=js"
export * from "./QkImage.vue?vue&type=script&lang=js"

import "./QkImage.vue?vue&type=style&index=0&id=4b0b3c9a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0b3c9a"]])

export default __exports__